// Mock data for Neha Nageswari Mohanty portfolio

export const personal = {
  name: "Neha Nageswari Mohanty",
  shortName: "Neha Nageswari",
  tagline: "Odia Cinema's Rising Luminary",
  currentlyStarring: "Tori Pai To Pai",
  network: "Tarang TV",
  signature: "Neha.",
  bio: `A magnetic presence on Odia television, Neha Nageswari Mohanty has redefined what it means to be a breakout star. From her debut in 2023 to becoming the most celebrated heroine consecutively in 2024 and 2025, her journey is a masterclass in versatility — blending grace, grit, and glamour in every frame she graces.`,
  longBio: `Born with an inherent flair for storytelling, Neha stepped into the limelight with the 2023 serial that announced her arrival. In "Tori Pai To Pai" on Tarang TV, she brings astonishing range — slipping seamlessly between characters within a single narrative and earning standing ovations from fans across Odisha.`,
  location: "Bhubaneswar, Odisha · India",
  languages: ["Odia", "Hindi", "English"],
  socials: {
    instagram: "https://www.instagram.com/neha_nageswari_official/",
    youtube: "https://www.youtube.com/channel/UCnemgse7egsa8w54eFkVDEA",
    nettv: "https://nettv4u.com/celebrity/odia/actress/neha-nageswari"
  }
};

export const heroStats = [
  { value: "2024 · 2025", label: "Best Heroine" },
  { value: "36+", label: "Music Videos" },
  { value: "10+", label: "Ad Films" },
  { value: "30+", label: "Brand Integration" },
  { value: "5+", label: "Awards & Honours" }
];

export const heroImages = {
  main: "/my-photo-7.jpg",
  secondary: "/my-photo-2.jpg",
  tertiary: "/my-photo-3.jpg",
};

export const currentlyStarring = {
  title: "Tori Pai To Pai",
  role: "Lead Heroine",
  network: "Tarang TV",
  year: "2023 — Present",
  description: "A sweeping family saga where Neha commands the screen with a performance of staggering versatility — portraying layered characters within a single arc. Fans and critics alike have called it the most magnetic lead role on Odia television this decade.",
  image: "/my-photo-4.jpg",
  highlights: [
    "Lead Heroine — Principal cast",
    "Multiple character arcs in a single narrative",
    "Primetime on Tarang TV",
    "Two consecutive Best Heroine wins (2024, 2025)"
  ]
};
export const musicVideos = [
  {
    id: "mv1",
    title: "Tate Jebe Bhala Paeili",
    featuring: "with Armaan Mohanty",
    year: "2025",
    runtime: "07:26",
    views: "1M+",
    description: "A tender, viral romance ballad that became an instant sensation across Odisha — celebrated for its honest chemistry and hauntingly cinematic frames.",
    cover: "https://img.youtube.com/vi/4Txcdv40qbo/maxresdefault.jpg",
    youtube: "https://youtu.be/4Txcdv40qbo",
    tag: "Romance"
  },
  {
    id: "mv2",
    title: "Kamala Rasa",
    featuring: "Dance Single",
    year: "2024",
    runtime: "04:32",
    views: "1M+",
    description: "The dance number that set the state on fire. Her trademark moves in Kamala Rasa spawned a wave of reels, tributes, and on-stage recreations.",
    cover: "https://img.youtube.com/vi/yxY4H05ILqE/maxresdefault.jpg",
    youtube: "https://youtu.be/yxY4H05ILqE",
    tag: "Dance Hit"
  },
  
  {
    id: "mv3",
    title: "Nabama 2.0",
    featuring: "Music Video",
    year: "2024",
    runtime: "07:30",
    views: "50k+",
    description: "A soulful Odia music video showcasing Neha at her most expressive and cinematic.",
    cover: "https://img.youtube.com/vi/uJ2pQAg_3wE/maxresdefault.jpg",
    youtube: "https://youtu.be/uJ2pQAg_3wE",
    tag: "Ballad"
  },
  {
    id: "mv4",
    title: "Pure Sunara Jhumka",
    featuring: "with Joydev",
    year: "2024",
    runtime: "06:17",
    views: "26M+",
    description: "A vibrant traditional Odia song celebrating culture and festivity with stunning visuals.",
    cover: "https://img.youtube.com/vi/wMAJkc_xcxg/maxresdefault.jpg",
    youtube: "https://youtu.be/wMAJkc_xcxg",
    tag: "Festival"
  },
  {
    id: "mv5",
    title: "Tu Mo Prema Re Achu",
    featuring: "Romantic Single",
    year: "2024",
    runtime: "06:36",
    views: "1M+",
    description: "A soulful Odia music video showcasing Neha at her most expressive and cinematic.",
    cover: "https://img.youtube.com/vi/9ehNWDThBCo/maxresdefault.jpg",
    youtube: "https://youtu.be/9ehNWDThBCo",
    tag: "Romance"
  },
  {
    id: "mv6",
    title: "Bhari Bhala Lage",
    featuring: "with Armaan Mohanty",
    year: "2025",
    runtime: "08:09",
    views: "200k+",
    description: "A soulful Odia music video showcasing Neha at her most expressive and cinematic.",
    cover: "https://img.youtube.com/vi/Rb48_3RhKa8/maxresdefault.jpg",
    youtube: "https://youtu.be/Rb48_3RhKa8",
    tag: "Romance"
  },
];
export const brands = [
  { 
    name: "Tanishq", 
    category: "Luxury Jewellery", 
    note: "Brand Film",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Tanishq_logo.svg/320px-Tanishq_logo.svg.png"
  },
  { 
    name: "Mia by Tanishq", 
    category: "Fine Jewellery", 
    note: "Campaign",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Tanishq_logo.svg/320px-Tanishq_logo.svg.png"
  },
  { 
    name: "CaratLane", 
    category: "Diamond Jewellery", 
    note: "Print & Digital",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/CaratLane_logo.svg/320px-CaratLane_logo.svg.png"
  },
  { 
    name: "Helios by Titan", 
    category: "Luxury Watches", 
    note: "In-store",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Titan_Company_Logo.svg/320px-Titan_Company_Logo.svg.png"
  },
  { 
    name: "Arundhati Jewellers", 
    category: "Heritage Jewellery", 
    note: "Brand Face",
    logo: "https://www.arundhatijewellers.com/assets/images/logo.png"
  },
  { 
    name: "Chandi Bhandar", 
    category: "Silver & Heritage", 
    note: "Ad Film",
    logo: "https://instagram.fhyd15-1.fna.fbcdn.net/v/t51.2885-19/236141743_3034441763541129_6734792686191590838_n.jpg?stp=dst-jpg_s150x150_tt6&efg=eyJ2ZW5jb2RlX3RhZyI6InByb2ZpbGVfcGljLmRqYW5nby41MjcuYzIifQ&_nc_ht=instagram.fhyd15-1.fna.fbcdn.net&_nc_cat=109&_nc_oc=Q6cZ2gHExW-iOpbiUbAvwMi3_o6FXO94jl1Rdte1WtoEdF5Ys7kgnUYZfkZ2VlTWBZX1YeI&_nc_ohc=gUFC1s9w3PEQ7kNvwEJOFhD&_nc_gid=V-kAJvwCRYHvqT6wlteioQ&edm=AOQ1c0wBAAAA&ccb=7-5&oh=00_Af1TtylaDKs4DZyNPY0TN0AF6YXX_o_zevbkkS9hMZQMlw&oe=69EB87A1&_nc_sid=8b3546"
  },
  { 
    name: "Nucleon Kota", 
    category: "Online Coaching", 
    note: "Digital Campaign",
    logo: "https://cdn-diy-public.classplus.co/prod/logowithoutbg_1735838906117.png"
  },
  { 
    name: "Himalayan", 
    category: "Skincare & Wellness", 
    note: "YouTube Deliverable",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/The_Himalaya_Drug_Company_logo.svg/320px-The_Himalaya_Drug_Company_logo.svg.png"
  },
  { 
    name: "30+ Brand Collabs", 
    category: "Makeup & Beauty", 
    note: "Multiple Campaigns",
    logo: null
  }
];

export const awards = [
  {
    id: "a1",
    title: "Raja Sundari — Winner",
    year: "2021",
    category: "Season 1 · Reality Show",
    note: "Crowned champion of Season 1 — the launchpad that introduced Neha to the world of Odia entertainment."
  },
  {
    id: "a2",
    title: "Women of Substance Awards",
    year: "2024",
    category: "Honoree",
    note: "Recognised for artistic influence and cultural impact."
  },
  {
    id: "a3",
    title: "Best Heroine — Tarang Parivaar Awards",
    year: "2024",
    category: "Best Actress in a Lead Role",
    note: "Crowned the most celebrated heroine in her breakout year."
  },
  {
    id: "a4",
    title: "Best Heroine — Tarang Parivaar Awards",
    year: "2025",
    category: "Best Actress in a Lead Role",
    note: "Retained the crown with a second consecutive win."
  },
  {
    id: "a5",
    title: "Best Jodi — Tarang Parivaar Awards",
    year: "2026",
    category: "On-screen Chemistry",
    note: "Honoured for the most beloved on-screen pairing of the year — a fan-voted celebration of chemistry and charm."
  },
  // {
  //   id: "a6",
  //   title: "Fan Favorite — Music Video",
  //   year: "2024",
  //   category: "Tate Jebe Bhala Paeili",
  //   note: "Recognition for viral on-screen chemistry."
  // }
];

export const filmography = [
  {
    year: "2021",
    title: "YouTube Journey Begins",
    role: "Content Creator",
    platform: "YouTube",
    note: "Started creating Odia content — dance, reels, and entertainment."
  },
  {
    year: "2021",
    title: "Raja Sundari — Season 1",
    role: "Contestant & Winner",
    platform: "Siddharth TV",
    note: "Competed and won Season 1 of Raja Sundari — the reality show that launched her into the spotlight."
  },
  {
    year: "2023",
    title: "Tori Pai To Pai ( Debut Serial )",
    role: "Lead Heroine",
    platform: "Tarang TV",
    note: "Primetime Odia serial — ongoing."
  },
  {
    year: "2024",
    title: "Music Videos — 36+",
    role: "Lead Artist",
    platform: "YouTube",
    note: "36+ music videos across Odia, Sambalpuri and Chhattisgarhi — romance, dance, folk and devotional."
  },
  {
    year: "2024",
    title: "Brand Collaborations — 30+",
    role: "Brand Integrations on Youtube",
    platform: "Digital & Print",
    note: "30+ brand deals including Himalayan, Dermdoc, and more beauty, jewellery and lifestyle brands."
  },
  {
    year: "2024",
    title: "Ad Shoots",
    role: "Lead Talent",
    platform: "Tv Ads & Digital Media",
    note: "Ad films for Tanishq, CaratLane, Mia by Tanishq, Helios by Titan , and many more."
  }
];

export const gallery = [
  { src: "/my-photo-6.jpg", tag: "Editorial", span: "tall" },
  { src: "/my-photo-1.jpg", tag: "Portrait", span: "normal" },
  { src: "/my-photo-8.jpg", tag: "Traditional", span: "normal" },
  { src: "/my-photo-9.jpg", tag: "Saree", span: "tall" },
  { src: "/my-photo-10.jpg", tag: "Campaign", span: "normal" },
  { src: "/my-photo-11.jpg", tag: "Glamour", span: "normal" },
  { src: "/my-photo-12.jpg", tag: "Cinematic", span: "tall" },
  { src: "/my-photo-13.jpg", tag: "Editorial", span: "normal", position: "object-center" },
  { src: "/my-photo-14.jpg", tag: "Portrait", span: "normal" , position: "object-center" },
  { src: "/my-photo-15.jpg", tag: "Beauty", span: "tall" },
  { src: "/my-photo-16.jpg", tag: "Studio", span: "normal" },
  { src: "/my-photo-17.jpg", tag: "Candid", span: "normal" }
];

export const press = [
  { quote: "A performer who turns every frame into a short film.", source: "Odia Entertainment Weekly" },
  { quote: "Two consecutive Best Heroine wins — and she is just getting started.", source: "Tarang TV Review" },
  { quote: "Kamala Rasa is more than a song. It's a cultural moment.", source: "Reel Culture Odisha" }
];
